import { useCallback } from 'react';
import {
  toggleDebugLogsModal as toggleDebugLogsModalAction,
  toggleDebugMode as toggleDebugModeAction,
} from '@redux/actions/searchActions';
import { IDebugModalConfig } from '@redux/reducers/searchReducer';
import {
  debugLogsSelector,
  debugModalConfigSelector,
  debugModeSelector,
} from '@redux/selectors/searchSelectors';
import { PartialBy } from '@redux/types/commonTypes';
import { useAppDispatch, useAppSelector } from './redux';

const useQueryDebugLogs = () => {
  const dispatch = useAppDispatch();
  const debugLogs = useAppSelector(debugLogsSelector);
  const debugModalConfig = useAppSelector(debugModalConfigSelector);
  const isDebugModeEnabled = useAppSelector(debugModeSelector);

  const toggleDebugMode = (enabled: boolean) => {
    dispatch(toggleDebugModeAction(enabled));
  };

  const toggleDebugLogsModal = (config: PartialBy<IDebugModalConfig, 'filters'>) => {
    dispatch(toggleDebugLogsModalAction({ ...config, filters: config.filters || {} }));
  };

  const getComponentDebugLogs = useCallback(
    (componentName: string) => {
      const componentDebugLogs = debugLogs.filter((log) => log && log[componentName]);
      const withOnlyComponentLogs = componentDebugLogs.reduce((acc, log) => {
        if (!log?.[componentName]) return acc;
        return [...acc, { [componentName]: log[componentName] }];
      }, [] as Record<string, unknown>[]);
      return withOnlyComponentLogs;
    },
    [debugLogs.length],
  );

  return {
    debugLogs,
    isDebugLogsModalOpen: debugModalConfig.isVisible,
    isDebugModeEnabled,
    debugLogsFilters: debugModalConfig.filters,
    getComponentDebugLogs,
    toggleDebugLogsModal,
    toggleDebugMode,
  };
};

export default useQueryDebugLogs;
